import React, { useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { loadCategories } from "../../../../../application/categories-slice";
import { useAppDispatch } from "../../../../../application/store";
import {
  CategoriesFailure,
  CategoriesRepository,
  Either,
} from "../../../../../domain";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";

type NewCategoryModalProps = {
  visible: boolean;
  onClose: () => void;
  parentId?: string;
  categoryType?: "category" | "subCategory" | "generalCategory";
};

const NewCategoryModal: React.FC<NewCategoryModalProps> = ({
  visible,
  onClose,
  categoryType,
  parentId,
}) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const submit = async () => {
    try {
      await form.validateFields();
      if (parentId === undefined || categoryType === undefined) return;
      setIsLoading(true);
      const categoriesRepository = ServiceLocater.get<CategoriesRepository>(
        Services.CategoriesRepository
      );
      let res: Either<CategoriesFailure, null>;
      if (categoryType === "generalCategory") {
        res = await categoriesRepository.addGeneralCategory(
          form.getFieldValue("title")
        );
      } else if (categoryType === "subCategory") {
        res = await categoriesRepository.addSubCategory(
          form.getFieldValue("title"),
          parentId
        );
      } else {
        res = await categoriesRepository.addCategory(
          form.getFieldValue("title"),
          parentId
        );
      }
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success(I18n.categories.success);
          dispatch(loadCategories());
          onClose();
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      title={"دسته‌بندی جدید"}
      visible={visible}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      onOk={submit}
      confirmLoading={isLoading}
      bodyStyle={{ paddingBottom: 0 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="عنوان"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input name="title" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default NewCategoryModal;
